export default __webpack_public_path__ + "static/media/other_services.ec69ca2c.svg";